import _ from 'lodash';
import React from 'react';
import {
  submit,
  startSubmit,
  isSubmitting,
  isInvalid,
  formValueSelector
} from 'redux-form';

import {
  MODALS,
  selectBooking,
  selectSelectedKycId,
  fetchKycs
} from 'ducks/bookings';
import {default as Modal, withModal} from 'components/Modal';

import {KycDocumentUploadForm, KycDocumentUploadButtons} from './components';

import './styles.css';

class KycDocumentUploadModal extends React.Component<any> {
  submitForm = () => {
    this.props.submit('kycDocumentUpload');
  };

  getExtraActions = () => {
    const {data: {bookingId, kycId}, fetchKycDetails} = this.props;

    return [
      ...this.props.closeModalExtraActions,
      () => fetchKycs({bookingId}),
      () => fetchKycDetails(kycId)
    ];
  };

  render() {
    const {
      closeModal,
      data: {uploading, noSelectedDocuments, kycId, form: {submitting, invalid}}
    } = this.props;
    const submitDisabled =
      submitting || invalid || uploading || noSelectedDocuments;

    return (
      <Modal
        show={true}
        onClose={closeModal}
        type={Modal.MEDIUM}
        className="KycDocumentUploadModal">
        <Modal.Header heading="Upload KYC documents" />
        <Modal.Body>
          <KycDocumentUploadForm
            kycId={kycId}
            getModalExtraActions={this.getExtraActions}
          />
        </Modal.Body>
        <Modal.Footer>
          <KycDocumentUploadButtons
            submitForm={this.submitForm}
            submitDisabled={submitDisabled}
            submitting={submitting}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const formSelector = formValueSelector('kycDocumentUpload');

const mapStateToModalData = state => {
  const kycId = selectSelectedKycId(state);
  const booking = selectBooking(state);
  const bookingId = _.get(booking, 'id');
  const noSelectedDocuments = _.isEmpty(
    formSelector(
      state,
      'identificationDocument',
      'visaDocument',
      'addressDocument'
    )
  );

  return {
    kycId,
    bookingId,
    noSelectedDocuments,
    form: {
      invalid: isInvalid('kycDocumentUpload')(state),
      submitting: isSubmitting('kycDocumentUpload')(state)
    }
  };
};
const mapDispatchToProps = {startSubmit, submit};

export default withModal(
  MODALS.KYC_DOCUMENT_UPLOAD,
  mapStateToModalData,
  mapDispatchToProps
)(KycDocumentUploadModal);
